<template>
<div class="model-17">
    <div class="video" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color}">
        <video :src="editablePageConfig.editable_page_config_content.video" controls></video>
    </div>
</div>

</template>

<script>
export default {
  name: 'Model17',
  data () {
    return {
    }
  },
  props: ['editablePageConfig','editablePage'],

  methods: {
    productClick(goods_id) {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.model-17 .video{
	border-radius: 5px;
}
.model-17 video{
	width: 100%;
 }
 </style>
